import axios from 'axios'

const baseURL = process.env.VUE_APP_DROP_ORDER_SERVICE + '/api/admin/payment-documents'

export default {
  namespaced: true,
  state: {
    new_payments: []
  },
  mutations: {
  },
  actions: {
    getDocumentList ({ state }, params) {
      return axios.get(baseURL, {
        params: params
      })
    },
    getNewPaymentDocuments ({ state }) {
      axios.get(baseURL + '/new').then(
        response => {
          state.new_payments = response.data.data
        }
      )
    },
    getDocumentFile ({ state }, params) {
      return axios.get(baseURL + '/show-file', {
        params: params,
        responseType: 'blob'
      })
    },
    updateDocument ({ state }, data) {
      return axios.put(baseURL + '/' + data.id, data)
    }
  }
}
